import {Component, NgZone, OnInit} from '@angular/core';
import {AppService} from '../app.service';
declare let $: any;
declare let window: any;
declare let UnityLoader: any;
declare let gameInstance: any;

@Component({
  selector: 'picture-this',
  templateUrl: './PictureThis.component.html',
  styleUrls: ['./PictureThis.component.css']
})
export class PictureThisComponent implements OnInit {
  // gameInstance = null;
  width = screen.width;
  height = screen.height;

  constructor(private app: AppService, private zone: NgZone) {
    console.log("Window height", this.height);
    console.log("Window width: ", this.width);
  }

  ngOnInit() {

  }
}
